// test1420
(1420 && 0);
